export enum EntityResponsivenessType {
    Great = 1,
    Alright = 2,
    Poor = 3,
    Unnaceptable = 4,
}

export const EntityResponsivenessTypeOptions = [
    {
        id: EntityResponsivenessType.Great,
        name: 'Great (same or next business day)',
    },
    {
        id: EntityResponsivenessType.Alright,
        name: 'Alright (2-3 business days)',
    },
    {
        id: EntityResponsivenessType.Poor,
        name: 'Poor (4-5 business days)',
    },
    {
        id: EntityResponsivenessType.Unnaceptable,
        name: 'Unacceptable (longer than a week or no reponse)',
    },
];
